export default [
{
    title: 'SMS',
    icon: 'MessageCircleIcon',
    children: [
        {
        title: 'Send New SMS',
        route: 'compose-message',
        },
        {
            title: 'Outbox',
            route: 'outbox',
        },
        {
            title: 'Schedule SMS Campaign',
            route: 'scheduled-messages',
        },
    ],
    }
];